import React from 'react';
import { Card, Typography } from 'antd';
import { Link } from 'react-router-dom';

const { Title, Paragraph } = Typography;

const AdminPage: React.FC = () => {
  return (
    <div style={{ maxWidth: 500, margin: '40px auto' }}>
      <Card hoverable style={{ borderRadius: 12, boxShadow: '0 2px 8px #f0f1f2' }}>
        <Title level={3}>Admin Tools</Title>
        <Paragraph>Access administrative oversight tools below:</Paragraph>
        <Card.Grid style={{ width: '50%', textAlign: 'center', padding: 24 }}>
          <Link to="/admin/orders" style={{ fontSize: 18, fontWeight: 500 }}>
            Order Management
          </Link>
        </Card.Grid>
        <Card.Grid style={{ width: '50%', textAlign: 'center', padding: 24 }}>
          <Link to="/admin/emails" style={{ fontSize: 18, fontWeight: 500 }}>
            Email Tracking
          </Link>
        </Card.Grid>
        <Card.Grid style={{ width: '100%', textAlign: 'center', padding: 24 }}>
          <Link to="/admin/client-properties" style={{ fontSize: 18, fontWeight: 500 }}>
            Client Properties
          </Link>
        </Card.Grid>
      </Card>
    </div>
  );
};

export default AdminPage;
